<div class="form-group actions-header" (click)="editable ? onPictureChange(stationAuditSelected, $event) : onViewPictureChange(stationAuditSelected)" *ngIf="!isTablet()" [ngClass]="!editable ? 'mb-3' : ''">
    <label class="switch mb-4 mt-2 d-block">
        <input type="checkbox" [checked]="stationAuditSelected && stationAuditSelected.withPicture" [disabled]="!editable">
        <span class="slider round"></span>
        <span class="status picture-label">{{ 'CHECK.STATION_AUDIT.WITH_PICTURE' | translate }}</span>
    </label>

    <span *ngIf="editable" class="delete-record-text" (click)="deleteStationAudit($event)" [ngClass]="isStationDeleteDisabled() ? 'disabled-delete' : ''">{{ 'CHECK.STATION_AUDIT.DELETE' | translate }}</span>
</div>

<div class="tab-stations">
    <div cdkDropListGroup class="gallery-container">
        <div class="display-row-none">
            <div class="gallery-grid" *ngFor="let itemsRow of getItemsTable()" cdkDropList
                cdkDropListOrientation="horizontal" [cdkDropListData]="itemsRow"
                (cdkDropListDropped)="editable && reorderDroppedItem($event)">
                <div *ngFor="let item of itemsRow; let i = index">
                    <div cdkDrag [cdkDragDisabled]=" item.id === 'btn-add' ? true : false" [cdkDragStartDelay]="500">
                        <div class="drag-placeholder" *cdkDragPlaceholder></div>
                        <div *ngIf="item.id !== '' && item.id !== 'btn-add'" class="gallery-box"
                            [ngClass]="{'selected': item.id === selectedId}"
                            [style.backgroundImage]="getGalleryImageUrl(item)" (click)="changeImage(item)">
                            <div class="canvas-circle" *ngIf="item.imageData && item.circleColor"
                            [style.background-image]="(item && item.withPicture) ? 'url('+item.imageData+')' : ''" (click)="changeImage(item)"></div>
                        </div>
                        <button #addStationButton *ngIf="item.id === 'btn-add' && editable" type="button" name="btn-add" class="btn btn-square"
                            (click)="addNewStationAudit()">
                            <img class="icon" src="assets/icons/plusOutlined.svg" />
                        </button>
                    </div>
                </div>
            </div>

            <button *ngIf="stationAudits.length >= 6" class="btn btn-collapse" type="button"
                (click)="viewAllElements()">
                {{ openCollapseGallery ? ('CHECK.SHOW_LESS' | translate) : ('CHECK.SHOW_MORE' | translate) }}
                <img
                    [src]=" openCollapseGallery ? 'assets/icons/chevronUpOutlined.svg' : 'assets/icons/chevronDownOutlined.svg'" />
            </button>
        </div>

        <div class="display-column-none flex-column align-items-center gallery-column">
            <!-- One dimension -->
            <div #galleryList cdkDropList class="gallery-column-list" (cdkDropListDropped)="editable && drop($event)">
                <div *ngFor="let item of getItemsTableVertical(); let i = index">
                    <!-- <div *ngIf="item.id === ''" class="gallery-box box-no-content" cdkDragDisabled="true" cdkDrag></div> -->
                    <div *ngIf="item.id != '' && item.id != 'btn-add'" class="gallery-box" cdkDrag
                        (click)="changeImage(item)" [cdkDragStartDelay]="500"
                        [ngClass]="selectedId === item.id ? 'selected': ''">
                        <img [src]="getGalleryImage(item)">
                        <div class="canvas-circle" *ngIf="item.imageData"
                            [style.background-image]="(item && item.withPicture) ? 'url('+item.imageData+')' : ''" (click)="changeImage(item)"></div>
                        <div class="gallery-label">{{ i + 1 }}</div>
                    </div>
                </div>
            </div>
            <!-- End One dimension -->
            <div class="btn-add-container">
                <button *ngIf="editable" type="button" class="btn-add-photo btn btn-square" (click)="addNewStationAudit()">
                    <img class="icon" src="assets/icons/plusOutlined.svg" />
                </button>
            </div>

        </div>
    </div>

    <div *ngIf="showNoPhotoAvailable()" class="no-available-image-box">
        <div class="form-group actions-header-tablet" (click)="editable ? onPictureChange(stationAuditSelected, $event) : onViewPictureChange(stationAuditSelected)" *ngIf="isTablet()">
            <label class="switch mb-4 mt-2 d-block">
                <input type="checkbox" [checked]="stationAuditSelected && stationAuditSelected.withPicture" [disabled]="!editable">
                <span class="slider round"></span>
                <span class="status picture-label">{{ 'CHECK.STATION_AUDIT.WITH_PICTURE' | translate }}</span>
            </label>
        
            <span *ngIf="editable" class="delete-record-text" (click)="deleteStationAudit($event)" [ngClass]="isStationDeleteDisabled() ? 'disabled-delete' : ''">{{ 'CHECK.STATION_AUDIT.DELETE' | translate }}</span>
        </div>

        <div class="no-images" [ngClass]="!isTablet() ? 'ps-3 pt-0 pb-0 pe-0' : ''">
            <div class="upload-image">
                <img class="icon" src="assets/icons/imageDisabled.svg" />
                <span class="info-message">{{ 'CHECK.NO_PHOTOS_AVAILABLE' | translate }}</span>
    
                <button *ngIf="editable" type="button" class="btn btn-square-responsive" (click)="takePicture($event)">
                    <img src="assets/icons/takePicture.svg" />
                    <span>{{ 'CHECK.TAKE_PHOTO' | translate }}</span>
                </button>
            </div>
    
            <lib-detail-image-form class="form-section-box" [stationAudit]="stationAuditSelected"
                [quickComments]="quickComments" [editable]="editable" (emitCreateStationAudit)="emitCreateStationAudit($event)"
                (emitClickTextarea)="emitClickTextarea.emit($event)"></lib-detail-image-form>
        </div>
    </div>

    <div *ngIf="!showNoPhotoAvailable()" class="available-image-box">
        <div class="form-group actions-header-tablet" (click)="editable ? onPictureChange(stationAuditSelected, $event) : onViewPictureChange(stationAuditSelected)" *ngIf="isTablet()">
            <label class="switch mb-4 mt-2 d-block">
                <input type="checkbox" [checked]="stationAuditSelected && stationAuditSelected.withPicture" [disabled]="!editable">
                <span class="slider round"></span>
                <span class="status picture-label">{{ 'CHECK.STATION_AUDIT.WITH_PICTURE' | translate }}</span>
            </label>
        
            <span *ngIf="editable" class="delete-record-text" (click)="deleteStationAudit($event)" [ngClass]="isStationDeleteDisabled() ? 'disabled-delete' : ''">{{ 'CHECK.STATION_AUDIT.DELETE' | translate }}</span>
        </div>

        <div class="image-section"  [ngClass]="isLandscapeTablet() && stationAuditSelected && !stationAuditSelected.withPicture ? 'position-row-normal' : ''">
            <div class="image-section-box" *ngIf="(originalImage || selectedImage) && stationAuditSelected && stationAuditSelected.withPicture" (click)="editable ? openEditModal($event) : setFullscreenOpen(true, $event)">
                <div class="preview-image" [style.background-image]="'url('+originalImage+')'">
                </div>
                <div class="canvas-circle" *ngIf="selectedImage != null"
                    [style.background-image]="'url('+selectedImage+')'">
                    <div>
                        <button *ngIf="editable" type="button" class="btn btn-rounded btn-retake-image"
                            (click)="retakeImage($event)">
                            <img class="icon" src="assets/icons/retakeImage.svg" />
                        </button>
    
                        <button type="button" class="btn-rounded" [ngClass]="editable ? 'btn-fullscreen-image' : 'btn-view-fullscreen-image'"
                            (click)="setFullscreenOpen(true, $event)">
                            <img class="icon" src="assets/icons/fullscreenWhite.svg" />
                        </button>
    
                        <button *ngIf="editable" type="button" class="btn btn-rounded btn-edit-image" (click)="openEditModal($event)">
                            <img class="icon" src="assets/icons/editWhite.svg" />
                        </button>
                    </div>
                </div>
                <div class="canvas-circle null-image" *ngIf="selectedImage == null && stationAuditSelected && stationAuditSelected.withPicture">
                    <div>
                        <button *ngIf="editable" type="button" class="btn btn-rounded btn-retake-image"
                            (click)="retakeImage($event)">
                            <img class="icon" src="assets/icons/retakeImage.svg" />
                        </button>
    
                        <button type="button" class="btn btn-rounded" [ngClass]="editable ? 'btn-fullscreen-image' : 'btn--view-fullscreen-image'"
                            (click)="setFullscreenOpen(true, $event)">
                            <img class="icon" src="assets/icons/fullscreenWhite.svg" />
                        </button>
    
                        <button *ngIf="editable" type="button" class="btn btn-rounded btn-edit-image" (click)="openEditModal($event)">
                            <img class="icon" src="assets/icons/editWhite.svg" />
                        </button>
                    </div>
                </div>
            </div>
            <lib-detail-image-form class="form-section-box" [ngClass]="stationAuditSelected && !stationAuditSelected.withPicture ? 'form-section-expand' : ''" [stationAudit]="stationAuditSelected"
                [quickComments]="quickComments" [editable]="editable" (emitCreateStationAudit)="emitCreateStationAudit($event)"
                (emitClickTextarea)="emitClickTextarea.emit($event)" (emitClearInterval)="emitClearInterval.emit($event)"></lib-detail-image-form>
        </div>
    </div>

    <div class="fullscreen-modal" *ngIf="isFullscreenModalOpen">
        <div class="container-image">
            <img class="image" [src]="originalImage" />
            <img class="canvas" [src]="selectedImage" />
        </div>

        <button type="button" class="btn-square btn-close-modal" (click)="setFullscreenOpen(false)">
            <img class="icon" src="assets/icons/closeBlueOutlined.svg" />
        </button>

        <button *ngIf="editable" type="button" class="btn btn-square btn-trash" (click)="deleteStationAudit($event)">
            <img class="icon" src="assets/icons/trashOutlined.svg" />
        </button>
    </div>
</div>